'use client';

import React from 'react';
import dynamic from 'next/dynamic';

// qrcode.react was a static import here before — since this file itself is a static import in
// header.tsx (rendered on every page) but QR codes only ever render inside an on-demand "scan to
// open app" modal, the library shipped to every page load while going ~85% unused in Lighthouse's
// script coverage (confirmed on shopstag-ci's homepage, which never opens that modal). Deferring
// the actual encoder to when this component first renders fixes that without touching header.tsx.
const QRCodeSVG = dynamic(() => import('qrcode.react').then(m => m.QRCodeSVG), { ssr: false });

interface QRCodeProps {
    value?: string;
    text?: string;
    size?: number;
    className?: string;
    bgColor?: string;
    fgColor?: string;
    level?: 'L' | 'M' | 'Q' | 'H';
    includeMargin?: boolean;
}

export function DynamicQRCode({
    value,
    text,
    size = 180,
    className = '',
    bgColor = '#FFFFFF',
    fgColor = '#000000',
    level = 'M',
    includeMargin = false
}: QRCodeProps) {
    const qrValue = value || text || '';
    if (!qrValue) return null;

    return (
        <div className={`inline-flex items-center justify-center p-2 bg-white rounded-xl shadow-xs border border-slate-200 ${className}`}>
            <QRCodeSVG
                value={qrValue}
                size={size}
                bgColor={bgColor}
                fgColor={fgColor}
                level={level}
                includeMargin={includeMargin}
            />
        </div>
    );
}
